import React from 'react';
import './ConfigTable.css';

const RowContents = ({children}) => {
  return (
    <div className='rowContents'>{children}</div>
  );
};

export default React.memo(RowContents);